var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('loading-indicator'):_c('q-page',{staticClass:"page-wrapper q-gutter-y-md",attrs:{"data-test":"wrapper:main"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }